/**
 * 日期格式化
 * @param {*} date
 * @param {*} format YmdHisu
 */
export const getFmtDate = (date, format) => {
  format = format || "Y-m-d H:i:s";

  if (Object.prototype.toString.call(date) != "[object Date]") {
    if (date) {
      date = date.replace(/-/g, "/");
      let temp = new Date(date);
      if (temp == "Invalid Date") {
        throw new Error("日期格式错误");
      } else {
        date = temp;
      }
    } else {
      date = new Date();
    }
  }

  return format.replace(/[YmdHisu]/g, function(string) {
    switch (string) {
      case "Y":
        return date.getFullYear().toString();
      case "m":
        return (date.getMonth() + 1).toString().padStart(2, "0");
      case "d":
        return date
          .getDate()
          .toString()
          .padStart(2, "0");
      case "H":
        return date
          .getHours()
          .toString()
          .padStart(2, "0");
      case "i":
        return date
          .getMinutes()
          .toString()
          .padStart(2, "0");
      case "s":
        return date
          .getSeconds()
          .toString()
          .padStart(2, "0");
      case "u":
        return date
          .getMilliseconds()
          .toString()
          .padStart(3, "0");
      default:
        return string;
    }
  });
};

/**
 * 获取时间戳
 * @param {*} date
 */
export const getTimestamp = (date) => {
  if (!date) {
    return +new Date();
  }
  date = date.replace(/-/g, "/");
  return +new Date(date);
};

/**
 * 获取倒计时
 * @param {*} _second
 * @param {*} format dhms
 * @returns
 */
export const getCountDown = (_second, format = "dhms") => {
  if (_second < 0) return;
  let _day;
  if (format.includes("d")) {
    _day = parseInt(_second / 24 / 60 / 60);
    _second -= _day * 24 * 60 * 60;
  }
  let _hour;
  if (format.includes("h")) {
    _hour = parseInt(_second / 60 / 60);
    _second -= _hour * 60 * 60;
  }
  let _mimnute;
  if (format.includes("m")) {
    _mimnute = parseInt(_second / 60);
    _second -= _mimnute * 60;
  }

  return format.replace(/[dhms]/g, function(s) {
    switch (s) {
      case "d":
        return _day.toString().padStart(2, "0");
      case "h":
        return _hour.toString().padStart(2, "0");
      case "m":
        return _mimnute.toString().padStart(2, "0");
      case "s":
        return _second.toString().padStart(2, "0");
      default:
        return s;
    }
  });
};

export const getQuery = (name, url) => {
  if (!url) url = location.href;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : results[1];
};

export const encodeMobile = (mobile, start = 3, end = 4) => {
  let regex = new RegExp(`^(\\d{${start}})(\\d*)(\\d{${end}}$)`);
  return mobile.replace(
    regex,
    (_, a, b, c) => `${a}${"*".repeat(b.length)}${c}`
  );
};
